import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export const ImmersiveExperienceSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const constraintsRef = useRef(null);
  const images = [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rru8mxg1f864Swgj1TtDBp/Gemini_Generated_Image_xf598lxf598lxf59.png',
    title: "Maharaja Ranjit Singh's Royal Procession",
    description: 'Stand in awe as the Lion of Punjab rides before you, surrounded by his loyal Khalsa army in this breathtaking 360° projection.'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2uRFx3az1Ndo6QPmwLotNT/Gemini_Generated_Image_6xdim76xdim76xdi.png',
    title: 'The Sikh Cavalry',
    description: 'Experience the might of the legendary Sikh cavalry with immersive projections that bring history to life.'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wVBxvpncFWjZ3U7V1C4TbV/Gemini_Generated_Image_cc8os5cc8os5cc8o.png',
    title: 'Twilight at the Palace',
    description: 'Step into the serene beauty of royal residences as they appeared during the height of the Sikh Kingdom.'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iav6C11v1iAqRNyzsLVGur/Gemini_Generated_Image_ouvfm7ouvfm7ouvf.png',
    title: "Maharaja's Grand Court",
    description: 'Walk through the magnificent courtyards and architecture of the royal Sikh palaces.'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iR78vrqsvQA53iTK4qhgmU/Gemini_Generated_Image_p2ylk0p2ylk0p2yl.png',
    title: 'The Khalsa Army',
    description: 'Witness the formidable Khalsa army that defended the Sikh Empire, brought to life through 360° projections.'
  }];
  const nextSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <section id="immersive-experience" className="py-20 md:py-28 bg-black relative overflow-hidden" data-id="element-1588" data-mp="2ooevspoj8bld">
      <div className="container mx-auto px-4" data-id="element-1589" data-mp="2kncvs6msjvic">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24" data-id="element-1590" data-mp="2yk9ibvvvmqtf">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-1591" data-mp="33duj1voutywb">
            Visual Chronicle
          </p>
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-1592" data-mp="3ccpsdgn73p3u">
            IMMERSIVE
            <br data-id="element-1593" data-mp="3vyhkg3g8qg1b" />
            <span className="text-amber-400" data-id="element-1594" data-mp="3vxyb3b4nozyw">PROJECTIONS</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-1595" data-mp="4rojn0pd0ixb"></div>
        </motion.div>
        <div className="relative max-w-7xl mx-auto" ref={constraintsRef} data-id="element-1596" data-mp="4pkeygjmzfvz">
          <div className="relative overflow-hidden rounded-lg" data-id="element-1597" data-mp="3mx9ymkuwv7o4">
            <AnimatePresence mode="wait" data-id="element-1598" data-mp="3qy3kz9spgeew">
              <motion.div key={currentIndex} initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} exit={{
              opacity: 0
            }} transition={{
              duration: 0.6
            }} className="relative" data-id="element-1599" data-mp="3r17veowrk6e0">
                <div className="aspect-[21/9] relative rounded-lg overflow-hidden" data-id="element-1600" data-mp="2u8w1e7bncfdm">
                  <img src={images[currentIndex].url} alt={images[currentIndex].title} className="w-full h-full object-cover" data-id="element-1601" data-mp="2ub8f28adg3kv" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" data-id="element-1602" data-mp="2m86g1ufldhg5"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-8 text-center bg-gradient-to-t from-black to-transparent" data-id="element-1603" data-mp="2hgodx31u1atl">
                  <h3 className="font-serif text-xl md:text-3xl lg:text-4xl text-amber-400 mb-2 md:mb-3" data-id="element-1604" data-mp="2dfmdiiw6isq1">
                    {images[currentIndex].title}
                  </h3>
                  <p className="text-white/80 text-sm md:text-lg max-w-3xl mx-auto font-light" data-id="element-1605" data-mp="23gx4zgq6akmg">
                    {images[currentIndex].description}
                  </p>
                </div>
              </motion.div>
            </AnimatePresence>
            <button onClick={prevSlide} className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/60 hover:bg-amber-400 hover:text-black text-white p-3 transition-colors duration-300 border border-white/10" aria-label="Previous slide" data-id="element-1606" data-mp="3swmstnjoyr2q">
              <ChevronLeft className="w-6 h-6" data-id="element-1607" data-mp="1fmd9if8bk826" />
            </button>
            <button onClick={nextSlide} className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/60 hover:bg-amber-400 hover:text-black text-white p-3 transition-colors duration-300 border border-white/10" aria-label="Next slide" data-id="element-1608" data-mp="1fkiqx7kiss19">
              <ChevronRight className="w-6 h-6" data-id="element-1609" data-mp="rqhasxf9eyzc" />
            </button>
          </div>
          <div className="flex justify-center mt-8 space-x-2" data-id="element-1610" data-mp="wo0y0mtxqm3f">
            {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`h-px transition-all duration-300 ${index === currentIndex ? 'w-12 bg-amber-400' : 'w-8 bg-white/30 hover:bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-1611" data-mp="10nrkwfgcci2o" data-mpi={index} />)}
          </div>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center max-w-3xl mx-auto mt-20" data-id="element-1612" data-mp="h0bid5z1ayq6">
          <p className="text-xl text-white/70 italic font-light" data-id="element-1613" data-mp="3uf7u6djjn220">
            "Step inside a living, breathing version of the Sikh Kingdoms —
            where you don't just see history, you experience it."
          </p>
        </motion.div>
      </div>
    </section>;
};